import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {BuildVersion} from '@mintdata-wsp/wsp/ui/components/general/BuildVersion';
import {CenteredContent} from '@mintdata-wsp/wsp/ui/components/general/CenteredContent';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {LogoHeader} from '@mintdata-wsp/wsp/ui/pages/general/LogoHeader';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./UnsupportedPage.less');
const cx = classnames.bind(styles);

@observer
export class UnsupportedPage extends BasePage<any, any>
{
    componentDidMount()
    {
        controllers.ui.anyPage.disablePageLoader();
    }

    render()
    {
        return  <div className={cx('unsupportedPage')}>
                    <LogoHeader/>
                    <BuildVersion/>

                    <CenteredContent>
                        <div className={cx('message')}>
                            <h1 className={cx('title')}>Unsupported browser</h1>
                            <div className={cx('description')}>
                                <p>You are using a web browser we don't support yet.</p>
                                <p>Please use one of these options to improve your experience.</p>
                            </div>
                            <Row>
                                <Column className={cx('bottomColumn')}>
                                    <Row>
                                        <Column className={cx('leftColumn')}>
                                            <div>
                                                <img width="128" alt="Google Chrome"
                                                     src="https://www.google.com/chrome/static/images/chrome-logo.svg" />
                                            </div>
                                            <div>
                                                <a className={cx('link')} target="_blank"
                                                   href="https://www.google.com/chrome">Google Chrome</a>
                                            </div>
                                            <div>
                                                <p>version 50.0+</p>
                                            </div>
                                        </Column>
                                        <Column className={cx('rightColumn')}>
                                            <div>
                                                <img width="128" alt="Mozilla Firefox"
                                                     src="https://www.mozilla.org/media/img/logos/firefox/logo-quantum-high-res.cfd87a8f62ae.png" />
                                            </div>
                                            <div>
                                                <a className={cx('link')} target="_blank"
                                                   href="https://www.mozilla.org/firefox/download">Mozilla Firefox</a>
                                            </div>
                                            <div>
                                                <p>version 44.0+</p>
                                            </div>
                                        </Column>
                                    </Row>
                                </Column>
                            </Row>

                        </div>
                    </CenteredContent>
                </div>;
    }
}
